const BASE_URL = 'dashboard';

export const PATHS = {
  BASE_URL,
  SCHEDULES: `${BASE_URL}/schedules`,
  TIMELINE_EVENT_DRAWER: `${BASE_URL}/schedules?&divId=:divId&triggerId=:triggerId&scheduleId=:scheduleId&gte=:gte&lte=:lte&dateKey=:dateKey&groupBy=:groupBy/events`,
  EVENT_TYPES_DRAWER: `${BASE_URL}/schedules?divId=:divId&gte=:gte&lte=:lte&interval=:interval&scheduleId=:scheduleId&dateKey=:dateKey&groupBy=:groupBy/event_types`,
  ACTIVE_SCHEDULES: `${BASE_URL}/active_schedules`,
  EVENTS: `${BASE_URL}/events`,
  EDIT_CHART: `${BASE_URL}/edit`,
  ACTIVE_USER_DASHBOARD: `${BASE_URL}/active_user`,
  ACTIVE_USER_DASHBOARD_TIMELINE: 'timeline/:userId',
  ACTIVE_USER_DASHBOARD_SCHEDULES: 'schedules/:userId',
  ACTIVE_CHECKPOINT_ROUTES_DASHBOARD: `${BASE_URL}/active_checkpoint_routes_dashboard`,
  CHECKPOINT_ROUTES: `${BASE_URL}/checkpoint-routes`,
  CHECKPOINT_ROUTES_TIMELINE_DRAWER: `${BASE_URL}/checkpoint-routes?divId=:divId&triggerId=:triggerId&scheduleId=:scheduleId&gte=:gte&lte=:lte&dateKey=:dateKey&groupBy=:groupBy/events`,
  TASKS: `${BASE_URL}/tasks`,
  OPERATION_REPORT: `${BASE_URL}/operation-report`,
  TASKS_TIMELINE_DRAWER: `${BASE_URL}/tasks?divId=:divId&triggerId=:triggerId&scheduleId=:scheduleId&gte=:gte&lte=:lte&dateKey=:dateKey&groupBy=:groupBy/events`,
  TASKS_EVENT_TYPES_DRAWER: `${BASE_URL}/tasks?divId=:divId&gte=:gte&lte=:lte&interval=:interval&scheduleId=:scheduleId&dateKey=:dateKey&groupBy=:groupBy/event_types`,
};

export const ACTIVE_SCHEDULES_LIST_VIEW_STORAGE_KEY = 'activeSchedulesList';
export const ACTIVE_CHECKPOINT_ROUTES_LIST_VIEW_STORAGE_KEY = 'activeCheckpointRoutesList';
export const ACTIVE_SCHEDULES_PAGE_SIZE = 25;
export const ACTIVE_CHECKPOINT_ROUTES_PAGE_SIZE = 25;

export const SELECT_PAGES_OPTIONS = [
  {
    label: 20,
    value: 20,
  },
  {
    label: 30,
    value: 30,
  },
  {
    label: 40,
    value: 40,
  },
  {
    label: 50,
    value: 50,
  },
];

export const getRouteToTimelineEventDrawer = (
  orgId = null,
  divId = null,
  triggerId = null,
  scheduleId = null,
  gte = null,
  lte = null,
  dateKey = null,
  groupBy = null,
) =>
  PATHS.TIMELINE_EVENT_DRAWER.replace(':orgId', orgId)
    .replace(':divId', divId)
    .replace(':triggerId', triggerId)
    .replace(':scheduleId', scheduleId)
    .replace(':gte', gte)
    .replace(':lte', lte)
    .replace(':dateKey', dateKey)
    .replace(':groupBy', groupBy);

export const getRouteToEventTypesDrawer = (
  divId,
  gte,
  lte,
  interval,
  scheduleId,
  dateKey,
  groupBy,
) =>
  PATHS.EVENT_TYPES_DRAWER.replace(':divId', divId)
    .replace(':gte', gte)
    .replace(':lte', lte)
    .replace(':interval', interval)
    .replace(':scheduleId', scheduleId)
    .replace(':dateKey', dateKey)
    .replace(':groupBy', groupBy);

export const getRouteToActiveSchedulesTimelineDrawer = ({
  divId,
  triggerId,
  triggerRefId,
  scheduleId,
  finishedExecutions,
  expectedExecutions,
}) => {
  const params = new URLSearchParams();

  if (divId) params.set('divId', divId);
  if (triggerId) params.set('triggerId', triggerId);
  // Original trigger definition id: events may be stored with it instead of `triggerId`.
  if (triggerRefId && triggerRefId !== triggerId) params.set('triggerRefId', triggerRefId);
  if (scheduleId) params.set('scheduleId', scheduleId);
  if (finishedExecutions != null) params.set('finishedExecutions', String(finishedExecutions));
  if (expectedExecutions != null) params.set('expectedExecutions', String(expectedExecutions));

  const query = params.toString();

  return query ? `${PATHS.ACTIVE_SCHEDULES}?${query}` : PATHS.ACTIVE_SCHEDULES;
};

/** Deep link that pre-filters an executions list down to a single execution. */
const buildRouteToExecution = (basePath, { executionId, divId }) => {
  if (!executionId || !divId) return basePath;

  const params = new URLSearchParams();
  params.set('executionId', executionId);
  params.set('divId', divId);

  return `${basePath}?${params.toString()}`;
};

export const getRouteToActiveSchedulesByExecution = ({ executionId, divId }) =>
  buildRouteToExecution(PATHS.ACTIVE_SCHEDULES, { executionId, divId });

export const getRouteToActiveCheckpointRoutesByExecution = ({ executionId, divId }) =>
  buildRouteToExecution(PATHS.ACTIVE_CHECKPOINT_ROUTES_DASHBOARD, { executionId, divId });

export const getRouteToCheckpointRoutesDrawer = (
  orgId = null,
  divId = null,
  triggerId = null,
  scheduleId = null,
  gte = null,
  lte = null,
  dateKey = null,
  groupBy = null,
) =>
  PATHS.CHECKPOINT_ROUTES_TIMELINE_DRAWER.replace(':orgId', orgId)
    .replace(':divId', divId)
    .replace(':triggerId', triggerId)
    .replace(':scheduleId', scheduleId)
    .replace(':gte', gte)
    .replace(':lte', lte)
    .replace(':dateKey', dateKey)
    .replace(':groupBy', groupBy);

export const getRouteToDashboardSchedules = () => PATHS.SCHEDULES;

export const getRouteToDashboardTasks = () => PATHS.TASKS;

export const getRouteToTasksTimelineDrawer = (
  orgId = null,
  divId = null,
  triggerId = null,
  scheduleId = null,
  gte = null,
  lte = null,
  dateKey = null,
  groupBy = null,
) =>
  PATHS.TASKS_TIMELINE_DRAWER.replace(':orgId', orgId)
    .replace(':divId', divId)
    .replace(':triggerId', triggerId)
    .replace(':scheduleId', scheduleId)
    .replace(':gte', gte)
    .replace(':lte', lte)
    .replace(':dateKey', dateKey)
    .replace(':groupBy', groupBy);

export const getRouteToTasksEventTypesDrawer = (
  divId,
  gte,
  lte,
  interval,
  scheduleId,
  dateKey,
  groupBy,
) =>
  PATHS.TASKS_EVENT_TYPES_DRAWER.replace(':divId', divId)
    .replace(':gte', gte)
    .replace(':lte', lte)
    .replace(':interval', interval)
    .replace(':scheduleId', scheduleId)
    .replace(':dateKey', dateKey)
    .replace(':groupBy', groupBy);
